import {AiCreativeType, Creative, CreativeType} from 'common/src/modules/creatives/creatives.types';
import {FilterToolSchemaField} from 'common/src/modules/shared/copilot/tools/filterTableTool/filterTableTool.types';

const creativeTypeConversions: Record<CreativeType, AiCreativeType> = {
  [CreativeType.Html]: AiCreativeType.Html,
  [CreativeType.Video]: AiCreativeType.Video,
  [CreativeType.Image]: AiCreativeType.Image,
  [CreativeType.Audio]: AiCreativeType.Audio,
  [CreativeType.InteractiveVideo]: AiCreativeType.InteractiveVideo,
  [CreativeType.InBannerVideo]: AiCreativeType.InBannerVideo,
};

const creativesSchema: FilterToolSchemaField<Creative>[] = [
  {name: 'id', type: 'number'},
  {name: 'name', type: 'string'},
  {
    name: 'type.value' as keyof Creative,
    type: 'number',
    description: `Should be converted from strings to strings and vice versa in the following way: ${Object.entries(
      creativeTypeConversions,
    )
      .map(([key, value]) => `${key}: ${value}`)
      .join(',')}`,
  },
  {name: 'createTime', type: 'string'},
  {name: 'updateTime', type: 'string'},
  {
    name: 'createdByUserName',
    type: 'string',
    description:
      'The user who created the creative template, might contain partial name (e.g. "John" VS "John Doe").',
  },
  {
    name: 'updatedByUserName',
    type: 'string',
    description:
      'The user who updated the creative template, might contain partial name (e.g. "John" VS "John Doe").',
  },
  {name: 'features', type: 'Array<string>'},
  {
    name: 'formats',
    type: 'Array<{width: number; height: number}>',
    description:
      'Creative format dimensions. Filter by width or height (e.g. width=300, height=250)',
  },
  {
    name: 'usedInCampaigns',
    type: 'Array<{campaignId: number; isUsedInActiveCampaignVersion: boolean; isCampaignActive: boolean}>',
    description:
      'Campaigns the creative is used in. If isUsedInActiveCampaignVersion is true, the creative is used in an active campaign version. If isCampaignActive is true, the campaign is active.',
  },
];

export {creativesSchema, creativeTypeConversions};
